import React from "react";
import { Box, CardContent, Grid, Typography } from "@mui/material";
import {
  SentimentSatisfiedAlt as SentimentSatisfiedAltIcon,
  SentimentVeryDissatisfied as SentimentVeryDissatisfiedIcon,
  SentimentNeutral as SentimentNeutralIcon,
  Call as CallIcon,
  AvTimer as AvTimerIcon,
  TimerOutlined as TimerOutlinedIcon,
  Mic as MicIcon,
} from "@mui/icons-material";
import { jwtDecode } from "jwt-decode";
import { palette, theme as colorTheme } from "../../../Convoze.theme";
export default function DashboardMetrics({ cardDetails, onMetricClick }) {

  const positive = colorTheme('palette', 'positive').value;
  const positiveBg = colorTheme('palette', 'positiveBg').value;
  const negative = colorTheme('palette', 'negative').value;
  const negativeBg = colorTheme('palette', 'negativeBg').value;
  const neutral = colorTheme('palette', 'neutral').value;
  const neutralBg = colorTheme('palette', 'neutralBg').value;
  const primary = colorTheme('palette', 'primary').value;
  const primaryBg = colorTheme('palette', 'primaryBg').value;


  const totalRecordss =
    Number(cardDetails?.sentimentCounts?.Positive) +
    Number(cardDetails?.sentimentCounts?.Neutral) +
    Number(cardDetails?.sentimentCounts?.Negative);

  const stored = localStorage.getItem("dashboardFilters");
  const decoded = stored ? JSON.parse(atob(stored)) : " ";
  const appliedSentiments = decoded?.filters?.sentiment || [];
  const isSentimentApplied =
    Array.isArray(appliedSentiments) && appliedSentiments.length > 0;

  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : "";
  const metrics = [
    {
      title: "Total Recordings",
      value: cardDetails?.sentimentCounts?.totalCallRecordings || 0,
      icon: MicIcon,
      iconBg: "#E9EFFC",
      iconColor: "#2463EB",
      trend: "0",
      filterPayload: { sentiment: [], status: "" },
    },
    {
      title: "Processed Recordings",
      value: isSentimentApplied
        ? totalRecordss
        : cardDetails?.sentimentCounts?.totalRecordings == 0
          ? cardDetails?.sentimentCounts?.Positive +
          cardDetails?.sentimentCounts?.Neutral +
          cardDetails?.sentimentCounts?.Negative
          : cardDetails?.sentimentCounts?.totalRecordings,
      icon: CallIcon,
      iconBg: "#EDE4FA",
      // iconColor: "#2463EB",
      iconColor: primary,
      trend: "+2.4",
      filterPayload: { sentiment: [], status: "processed" },
    },
    {
      title: "Positive Sentiment",
      value: cardDetails?.sentimentCounts?.Positive || 0,
      icon: SentimentSatisfiedAltIcon,
      iconBg: "#E8F9EE",
      // iconColor: "#44CD77",
      iconColor: positive,
      trend: "-2.4",
      filterPayload: { sentiment: ["Positive"], status: "" },
    },
    {
      title: "Neutral Sentiment",
      value: cardDetails?.sentimentCounts?.Neutral || 0,
      icon: SentimentNeutralIcon,
      iconBg: "#FEF9EA",
      // iconColor: "#F8C630",
      iconColor: neutral,
      trend: "0",
      filterPayload: { sentiment: ["Neutral"], status: "" },
    },
    {
      title: "Negative Sentiment",
      value: cardDetails?.sentimentCounts?.Negative || 0,
      icon: SentimentVeryDissatisfiedIcon,
      iconBg: "#FBE9E9",
      // iconColor: "#DC2828",
      iconColor: negative,
      trend: "+2.4",
      filterPayload: { sentiment: ["Negative"], status: "" },
    },
    ...(decodedToken?.companyId === "67e560a6ae2e0d3f96b5eb08"
      ? [
        {
          title: "Less Than 2 Min",
          value: cardDetails?.sentimentCounts?.lessThanTwoMinutes || 0,
          icon: TimerOutlinedIcon,
          iconBg: "#E9EFFC",
          // iconColor: "#2463EB",
          iconColor: "#6366F1",
          trend: "-2.4",
          filterPayload: { callDurationText: ["Upto 2 Mins"] },
        },
      ]
      : []),

  ];

  const MetricCard = ({ metric }) => (
    <Box
      sx={{
        height: "100%",
        borderRadius: 3,
        border: "1px solid #EEEEEE",
        backgroundColor: "#fff",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      }}

      onClick={() => onMetricClick?.(metric.filterPayload)}
    >
      <Box
        sx={{ p: 3, }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            cursor: "pointer"
          }}
        >
          <Box>
            <Typography
              variant="subtitle1"
              sx={{
                color: "#1C252E",
                fontSize: "0.785rem",
                fontWeight: 600,
                fontFamily: `"Public Sans Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
                mb: 1.5,
                lineHeight: 1.57143,
              }}
            >
              {metric?.title}
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                mb: 0.5,
                fontFamily: `Barlow, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
              }}
            >
              {metric?.value}
            </Typography>
            {/* <Typography
              variant="caption"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 0.5,
                textAlign: "center",
                fontFamily: `Barlow, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
              }}
            >
              {metric?.trend > 0 ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  class="iconify iconify--solar minimal__iconify__root css-vwvpzv"
                  id="«r3fl»"
                  width="1.9em"
                  height="1.9em"
                  viewBox="0 0 24 24"
                  // color="#44CD77"
                  color={positive}
                >
                  <path
                    fill="currentColor"
                    d="M5 17.75a.75.75 0 0 1-.488-1.32l7-6a.75.75 0 0 1 .976 0l7 6A.75.75 0 0 1 19 17.75z"
                    opacity="0.4"
                  ></path>
                  <path
                    fill="currentColor"
                    fill-rule="evenodd"
                    d="M4.43 13.488a.75.75 0 0 0 1.058.081L12 7.988l6.512 5.581a.75.75 0 1 0 .976-1.138l-7-6a.75.75 0 0 0-.976 0l-7 6a.75.75 0 0 0-.081 1.057"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              ) : metric?.trend < 0 ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  role="img"
                  class="iconify iconify--solar minimal__iconify__root css-10vzt5"
                  id="«r3fn»"
                  width="1.9em"
                  height="1.9em"
                  viewBox="0 0 24 24"
                  // color="#DC2828"
                  color={negative}
                >
                  <path
                    fill="currentColor"
                    d="M5 6.25a.75.75 0 0 0-.488 1.32l7 6c.28.24.695.24.976 0l7-6A.75.75 0 0 0 19 6.25z"
                    opacity="0.4"
                  ></path>
                  <path
                    fill="currentColor"
                    fill-rule="evenodd"
                    d="M4.43 10.512a.75.75 0 0 1 1.058-.081L12 16.012l6.512-5.581a.75.75 0 1 1 .976 1.139l-7 6a.75.75 0 0 1-.976 0l-7-6a.75.75 0 0 1-.081-1.058"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  role="img"
                  class="iconify iconify--solar minimal__iconify__root css-10vzt5"
                  width="1.9em"
                  height="1.9em"
                  viewBox="0 0 24 24"
                  color="#9CA3AF"
                >
                  <path
                    fill="currentColor"
                    d="M5 12.75a.75.75 0 0 1 0-1.5h14a.75.75 0 0 1 0 1.5z"
                    opacity="0.4"
                  ></path>
                  <path
                    fill="currentColor"
                    fill-rule="evenodd"
                    d="M4.43 11.25a.75.75 0 0 1 .75-.75h13.64a.75.75 0 0 1 0 1.5H5.18a.75.75 0 0 1-.75-.75"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              )}
              {metric?.trend}% last 7 days
            </Typography> */}
          </Box>

          <Box
            sx={{
              bgcolor: metric.iconBg,
              borderRadius: 3,
              width: 52,
              height: 52,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <metric.icon sx={{ color: metric?.iconColor, fontSize: 25 }} />
          </Box>
        </Box>
      </Box>
    </Box>
  );

  const cardCount = metrics?.length || 1;

  return (
    <Grid container spacing={2} >
      {metrics?.map((metric, index) => (
        <Grid
          item
          key={index}
          xs={12}
          sm={6}
          md={4}
          lg={12 / cardCount}
        >
          <MetricCard metric={metric} />
        </Grid>
      ))}
    </Grid>
  );
}
